<footer class="landing-a__footer">
  <div class="landing-a__container landing-a__footer-grid">
    <div class="landing-a__footer-brand">
      <img class="landing-a__brand-logo" [src]="heroLogoSrc" alt="Treeslo" />
      <p>{{ 'landing.landing_1.footer.tagline' | translate }}</p>
    </div>

    @for (column of footerColumns; track column.titleKey) {
      <div class="landing-a__footer-column">
        <h4>{{ column.titleKey | translate }}</h4>
        <ul>
          @for (link of column.links; track link.key) {
            <li>
              <a [href]="footerLinkHref(link)">
                {{ 'landing.landing_1.footer.links.' + link.key | translate }}
              </a>
            </li>
          }
        </ul>
      </div>
    }
  </div>

  <div class="landing-a__container landing-a__footer-bottom">
    <span>{{ 'landing.landing_1.footer.copyright' | translate }}</span>
  </div>
</footer>
